export enum SectionTypes {
    CATEGORY = 'category',
    FEATURED = 'featured_collection',
    LINK_BASED = 'link_based',
    SPONSORED = 'sponsored',
    TOP_TRENDING = 'top_trending',
    RECOMMENDATIONS = 'recommended',
    CONTENT = 'article_content',
    WORDPRESS_SLUG_CONTENT = 'wordpress_slug_content',
    WHERE_LEFT_OFF = 'pick_up',
    TOAST = 'toast',
}

export type SectionDimensions = {
    cols: number;
    rows: number;
};

export type CallToAction = {
    name?: string;
    label?: string;
    url?: string;
};

export type Image = {
    url?: string;
    altText?: string;
};

export interface ListingCategory {
    name: string;
    filter: string;
}

export interface Content {
    id: string;
    title: string;
    type: string;
    description: string;
    callToAction?: CallToAction;
    image: Image | string;
    listingUrl?: string;
    publisher?: string;
    averageRating?: number;
    reviewsAmount?: number;
    key?: string;
    listingCategories?: ListingCategory[];
    sponsoredCampaigns?: AnyObject[];
    alt_text?: string;
}

export interface SectionProps {
    url?: string;
    id?: string;
    title?: string;
    description?: string;
    callToAction?: CallToAction;
    image?: Image;
    showMore?: CallToAction;
    layout?: AnyObject;
    records?: Content[];
    spreadProps?: AnyObject;
}

export interface Section {
    type: string;
    props: SectionProps;
}

// CallToActionComponent can be Tag, Button, Link, etc
export interface CallToActionComponent {
    props?: {
        callToAction?: CallToAction;
    };
}
export interface Category {
    id: string;
    callToAction: CallToAction;
}
